import Example from '../modules/blocks/example';
import Hero from '../modules/blocks/hero';
import About from '../modules/blocks/about';
import ImagesList from '../modules/blocks/images-list';
import Team from '../modules/blocks/team';
import VideoSlider from '../modules/blocks/video-slider';
import Gallery from '../modules/blocks/gallery';
import Testimonials from '../modules/blocks/testimonials';

function entry () {
    new Example('.example');
    new Hero('.hero');
    new About('.about');
    new ImagesList('.images-list');
    new Team('.team');
    new VideoSlider('.video-slider');
    new Gallery('.gallery');
    new Testimonials('.testimonials');
}

window.addEventListener('DOMContentLoaded', entry);
